/**
 * Animated error message banner for match-flow node player views.
 *
 * Mounts/unmounts via AnimatePresence so the layout collapses cleanly
 * when there's no error. Drops trailing margins so it doesn't stack
 * with the outer container's padding.
 */

import { AnimatePresence, motion } from "framer-motion";

type ErrorBannerProps = {
  error: string | null | undefined;
};

export function ErrorBanner({ error }: ErrorBannerProps) {
  return (
    <AnimatePresence>
      {error && (
        <motion.p
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          className="text-error-400 text-sm text-center"
        >
          {error}
        </motion.p>
      )}
    </AnimatePresence>
  );
}
